<template>
<div class="dboard-filter">
  <div class="row primary-filter">
  <div class="col-3 filter-grid">
    <ul>
      <li class="app-side-menu">
        <span @click="openMenu" class="pointer">
          <svgicon name="menu-light" width="20" height="20" :original="true" class="menu" />
        </span>
        <div class="sidemenu-slideout" :class="{ isOpen: isOpen }">
          <Sidebar v-on:close="onCloseMenu"/>
        </div>
      </li>
      <li class="color-changes category">
        <FilterDropdownCommon
          v-if="menuOptions.length"
          :options="menuOptions"
          :selected="selectedCategory"
          :isDarkTheme="isDarkTheme"
          v-on:updateOption="onChangeOption"
        />
      </li>
    </ul>
  </div>
  <div class="col-9 filter-grid filter-button">
    <ul class="filter-btn-group">
      <li class="category transporters" v-if="selectedTransporter">
        <FilterDropdown :options="transporterList"
        :selected="selectedTransporter"
        :noUpperCase="true"
        :isDarkTheme="isDarkTheme"
        v-on:updateOption="option=>$emit('transporterchange', option)" />
      </li>
      <li class="category depots">
        <DepotDropdown :options="options"
        :selected="seletedOption"
        v-on:updateOption="option=>$emit('depotchange', option)" />
      </li>
      <li class="category months">
        <FilterDropdown :options="months"
        :selected="selectedMonth"
        :noUpperCase="true"
        :isDarkTheme="isDarkTheme"
        v-on:updateOption="option=>$emit('monthchange', option)" />
      </li>
      <li class="category date">
        <dateDropDown :options="dateList"
        :selected="selectedDay"
        v-on:updateOption="option=>$emit('daychange', option)" />
      </li>
      <li class="category years">
        <FilterDropdown :options="years"
        :selected="selectedYear"
        :isDarkTheme="isDarkTheme"
        v-on:updateOption="option=>$emit('yearchange', option)" />
      </li>
    </ul>
  </div>
</div>
</div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import FilterDropdownCommon from '@common/components/FilterDropdown';
import FilterDropdown from '@/components/common/FilterDropdown';
import DepotDropdown from '@/components/common/depotDropdown';
import dateDropDown from '@/components/common/dateDropDown';
import Sidebar from '@/components/common/Sidebar';
import ReportList from './Reportlist';

export default {

  props: ['placeholder', 'options', 'seletedOption',
    'activeIntends', 'months', 'selectedMonth', 'years', 'selectedYear',
    'transporterList', 'selectedTransporter', 'filterTitle', 'menuOptions', 'selectedCategory'],

  components: {
    FilterDropdown, Sidebar, ReportList, dateDropDown, DepotDropdown, FilterDropdownCommon,
  },

  data() {
    return {
      reportlist: false,
      isOpen: false,
      query: null,
      hideBulk: ['OrdersList',  'Depot', 'OutboundIndentsV2', 'InboundIndentsV2'],
      hideAdd: ['rateMatrix', 'Detention'],
      currentRoute: '',
      reports: [],
      showDatePicker: false,
      startDate: this.$moment(new Date()).startOf('month').format('YYYY-MM-DD'),
      endDate: this.$moment(new Date()).endOf('month').format('YYYY-MM-DD'),
      isDarkTheme: true,
    };
  },
  created() {
    this.currentRoute = this.$router.history.current.name;
  },
  methods: {
    onClickDatePicker() {
      this.showDatePicker = true;
    },
    applyDates() {
      if (this.startDate && this.endDate) {
        this.startDate = this.$moment(this.startDate).toISOString();
        this.endDate =  this.$moment(this.endDate).endOf('day').toISOString();
      }
    },
    async indentFreightReport() {
      let params = {
        depot_id: this.seletedOption,
      };
      if (this.transporterSelected) {
        params = Object.assign(params, { transporter_id: this.transporterSelected});
      }
      const result = await this.$store.dispatch('report/freightProvision', params);
      if (result) {
          this.$success({
            message: result.data.message,
          });
        } else {
          this.$error({
            message: `Something Went Wrong`,
          });
        }
    },
    buccBifurcation(){
      let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      if (this.transporterSelected) {
        params = Object.assign(params, { transporter_id: this.transporterSelected});
      }
      this.$store.dispatch('report/buccBifurcation', params);
    },
    indentReport() {
      let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      if (this.transporterSelected) {
        params = Object.assign(params, { transporter_id: this.transporterSelected});
      }
      this.$store.dispatch('report/indents', params);
    },
    varianceReport() {
      const params = {
        depot_id: this.seletedOption,
        date: this.$moment(this.startDate).startOf('day').toISOString(),
      };
      this.$store.dispatch('optima/varianceDownload', params);
    },
    outlierReport() {
      const params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      this.$store.dispatch('report/sla', params);
    },
    invoiceReport() {
      let params = {
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      if (this.transporterSelected) {
        params = Object.assign(params, { transporter_id: this.transporterSelected});
      }
      this.$store.dispatch('report/invoice', params);
    },
    transitReliability() {
      let params = {
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      if (this.transporterSelected) {
        params = Object.assign(params, { transporter_id: this.transporterSelected});
      }
      this.$store.dispatch('report/transit_reliability', params);
    },
    delayReport() {
      let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      if (this.transporterSelected) {
        params = Object.assign(params, { transporter_id: this.transporterSelected});
      }
      this.$store.dispatch('report/delayReport', params);
    },
    gitReports() {
      let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      this.$store.dispatch('report/gitReports', params);
    },
    contractAdherence() {
      let params = {
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      this.$store.dispatch('report/contractAdherence', params);
    },
    async transporterPerformance() {
        try {
            let params = {
                depot_id: this.seletedOption,
                start: this.$moment(this.startDate).startOf('day').toISOString(),
                end: this.$moment(this.endDate).endOf('day').toISOString(),
            };
            if (this.transporterSelected) {
                params = Object.assign(params, { transporter_id: this.transporterSelected});
            }
            const result = await this.$store.dispatch('report/transporterPerformance', params);
            if (result) {
                const errors = result.data.errors;
                if (errors) {
                    this.$error({
                        message: errors[0].message,
                    });
                } else {
                    this.$success({
                        message: result.data.message,
                    });
                }

            } else {
                this.$error({
                    message: `Something Went Wrong`,
                });
            }
        } catch (error) {
            console.log(error);
        }
    },
    movementReport() {
      let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      if (this.transporterSelected) {
        params = Object.assign(params, { transporter_id: this.transporterSelected});
      }
      this.$store.dispatch('report/movementReport', params);
    },
    capacityUtil() {
      let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      if (this.transporterSelected) {
        params = Object.assign(params, { transporter_id: this.transporterSelected});
      }
      this.$store.dispatch('report/capacityUtil', params);
    },
    exceptionReport() {
      let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      this.$store.dispatch('report/exceptionReport',params);
    },
    unloaderIndent() {
      let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      this.$store.dispatch('report/indents_wo_materials', params);
    },
    unknowMaterials() {
      let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      this.$store.dispatch('report/unknowMaterials', params);
    },
    materialInvoiceFreightCost() {
      let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      this.$store.dispatch('report/materialInvoiceFreightCost', params);
    },
    indentsCount() {
      let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      this.$store.dispatch('report/indentsCount', params);
    },
    eximIndentStatusReport() {
      let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      this.$store.dispatch('report/eximIndentStatus', params);
    },
    eximAirMovementImportReport() {
      let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      this.$store.dispatch('report/eximAirMovementImport', params);
    },
    eximAirMovementExportReport() {
      let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      this.$store.dispatch('report/eximAirMovementExport', params);
    },
    onChangeOption(data) {
      if (data.id !== 'LiveDashboard') {
        this.$router.push({ name: 'Dashboard', query: { id: data.id }});
      } else {
        this.$router.push({ name: data.id });
      }
    },
    onCloseMenu() {
      this.isOpen = false;
    },
    openMenu: function open() {
      this.isOpen = true;
    },
    selectedReports(data) {
      this.reports = data;
    },
    generateReport() {
      if (this.reports.includes('BUCC Bifurcation')) {
        this.buccBifurcation();
      }
      if (this.reports.includes("Exim Indent Status Report")) {
        this.eximIndentStatusReport();
      }
      if (this.reports.includes("Exim Air Movement Import Report")) {
        this.eximAirMovementImportReport();
      }
      if (this.reports.includes("Exim Air Movement Export Report")) {
        this.eximAirMovementExportReport();
      }
      if (this.reports.includes("Contract Adherence Report")) {
        this.contractAdherence();
      }
      if (this.reports.includes('Freight Provision')) {
        this.indentFreightReport();
      }
      if (this.reports.includes('Indent Status Report')) {
        this.indentReport();
      }
      if (this.reports.includes('Outlier Report')) {
        this.outlierReport();
      }
      if (this.reports.includes('Invoice')) {
        this.invoiceReport();
      }
      if (this.reports.includes('Delay Report')) {
        this.delayReport();
      }
      if (this.reports.includes("GIT Report")) {
        this.gitReports();
      }
      if (this.reports.includes("Transit Reliability Report")) {
        this.transitReliability();
      }
      if (this.reports.includes('Transporter Performance')) {
        this.transporterPerformance();
      }
      if (this.reports.includes('Movement Data')) {
        this.movementReport();
      }
      if (this.reports.includes('Capacity Utilisation')) {
        this.capacityUtil();
      }
      if (this.reports.includes('Shipment Unmapped Report')) {
        this.exceptionReport();
      }
      if (this.reports.includes('Indents without Materials')) {
        this.unloaderIndent();
      }
      if (this.reports.includes('Unknown Materials')) {
        this.unknowMaterials();
      }
      if (this.reports.includes('Indents Count')) {
        this.indentsCount();
      }
      if (this.reports.includes('Material Invoice and Freight Spent')) {
        this.materialInvoiceFreightCost();
      }
      if (this.reports.includes('Optima Variance Report')) {
        this.varianceReport();
      }
      if (this.reports.includes('Inbound Indent Status')) {
        this.inboundIndentStatus();
      }
      if (this.reports.includes('Optima Vs Dispatch Materials')) {
        this.optimaVsDispatchMaterial();
       }
      if (this.reports.includes('Vehicle Types Bifurcation Report')) {
        this.vehicleTypesBifurcationReport();
      }
      if (this.reports.includes('Open market placements')) {
        this.openMarketPlacements();
      }
      if (this.reports.includes('Payment Compliance Report')) {
        this.paymentComplianceReport();
      }
      if (this.reports.includes('Total Distance Report')) {
        this.totalDistanceReport();
      }
      if (this.reports.includes('Track And Trace Report')) {
        this.trackAndTraceReport();
      }
    },
    async openMarketPlacements() {
      let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      const result = await this.$store.dispatch('report/openMarketPlacementReport', params);
      if (result) {
        this.$success({
          message: result.data.message,
        });
      } else {
        this.$error({
          message: `Something Went Wrong`,
        });
      }
    },
    async inboundIndentStatus() {
      try {
        let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      if (this.transporterSelected) {
        params = Object.assign(params, { transporter_id: this.transporterSelected});
      }
      const result = await this.$store.dispatch('report/inboundIndentStatus', params);
      if (result) {
          this.$success({
            message: result.data.message,
          });
      } else {
        this.$error({
          message: `Something Went Wrong`,
        });
      }
      } catch (error) {
        console.log(error);
      }

    },
    async vehicleTypesBifurcationReport() {
      try {
        let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      if (this.transporterSelected) {
        params = Object.assign(params, { transporter_id: this.transporterSelected});
      }
      const result = await this.$store.dispatch('report/vehicleTypesBifurcationReport', params);
      if (result) {
          this.$success({
            message: result.data.message,
          });
      } else {
        this.$error({
          message: `Something Went Wrong`,
        });
      }
      } catch (error) {
        console.log(error);
      }
    },

    async trackAndTraceReport() {
      try {
        let params = {
            depot_id: this.seletedOption,
            start: this.$moment(this.startDate).startOf('day').toISOString(),
            end: this.$moment(this.endDate).endOf('day').toISOString(),
        };
        const result = await this.$store.dispatch('report/trackAndTraceReport', params);
        if (result) {
            this.$success({
                message: result.data.message,
            });
        } else {
            this.$error({
                message: `Something Went Wrong`,
            });
        }
      } catch (error) {
        console.log(error);
      }
    },

    async optimaVsDispatchMaterial() {
      try {
        let params = {
        depot_id: this.seletedOption,
        start: this.$moment(this.startDate).startOf('day').toISOString(),
        end: this.$moment(this.endDate).endOf('day').toISOString(),
      };
      if (this.transporterSelected) {
        params = Object.assign(params, { transporter_id: this.transporterSelected});
      }
      const result = await this.$store.dispatch('report/optimaVsDispatchMaterial', params);
      if (result) {
          this.$success({
            message: result.data.message,
          });
      } else {
        this.$error({
          message: `Something Went Wrong`,
        });
      }
      } catch (error) {
        console.log(error);
      }

    },
    async paymentComplianceReport() {
      try {
        let params = {
          depot_id: this.seletedOption,
          start: this.$moment(this.startDate).startOf('day').toISOString(),
          end: this.$moment(this.endDate).endOf('day').toISOString(),
        };
        if (this.transporterSelected) {
          params = Object.assign(params, { transporter_id: this.transporterSelected});
        }
        const result = await this.$store.dispatch('report/paymentComplianceReport', params);
        if (result) {
          this.$success({
            message: result.data.message,
          });
        } else {
          this.$error({
            message: `Something Went Wrong`,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async totalDistanceReport() {
      try {
        let params = {
          start: this.$moment(this.startDate).startOf('day').toISOString(),
          end: this.$moment(this.endDate).endOf('day').toISOString(),
        };
        const result = await this.$store.dispatch('report/totalDistanceReport', params);
        if (result) {
          this.$success({
            message: result.data.message,
          });
        } else {
          this.$error({
            message: `Something Went Wrong`,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  computed: {
    ...mapGetters({
      depots: 'app/depots',
    }),
    defaultDepot() {
      return this.depots && this.depots[0];
    },
    transporterSelected() {
      return this.selectedTransporter.id;
    },
    dateList() {
      let days = new Date(this.selectedYear.name, this.selectedMonth.id, 0).getDate();
      let list = [...Array(days)].map((v,i)=>{
        return { name: i+1, id: i+1 };
      });
      list.unshift({ name: 'None', id: 0 })

      this.selectedDay = list[0];
      return list;
    },
    formattedStartDate() {
      return this.$moment(this.startDate).format('DD MMM YY');
    },
    formattedEndDate() {
      return this.$moment(this.endDate).format('DD MMM YY');
    }
  },
};
</script>

<style scoped lang="scss">
@import "~@common/styles-shipper/settings";

.categoryselect {
  border-color: #121e2d;
}
</style>
